var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPublishedWithChanges(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.25 13.9531C6.51042 13.8594 5.82031 13.6406 5.17969 13.2969C4.53906 12.9531 3.98438 12.5156 3.51562 11.9844C3.04688 11.4531 2.67708 10.8464 2.40625 10.1641C2.13542 9.48177 2 8.76042 2 8C2 7.09375 2.18229 6.25781 2.54688 5.49219C2.91146 4.72656 3.40625 4.0625 4.03125 3.5H2.75V2.375H6.125V5.75H5V4.15625C4.42708 4.60417 3.97135 5.16146 3.63281 5.82812C3.29427 6.49479 3.125 7.21875 3.125 8C3.125 9.22917 3.52083 10.2943 4.3125 11.1953C5.10417 12.0964 6.08333 12.6354 7.25 12.8125V13.9531ZM7.20312 10.25L5.07812 8.125L5.875 7.32812L7.20312 8.65625L10.125 5.75L10.9219 6.53125L7.20312 10.25ZM9.875 13.625V10.25H11V11.8438C11.5729 11.3958 12.0286 10.8385 12.3672 10.1719C12.7057 9.50521 12.875 8.78125 12.875 8C12.875 6.77083 12.4792 5.70573 11.6875 4.80469C10.8958 3.90365 9.91667 3.36458 8.75 3.1875V2.04688C10.2396 2.23438 11.487 2.88802 12.4922 4.00781C13.4974 5.1276 14 6.45833 14 8C14 8.90625 13.8177 9.74219 13.4531 10.5078C13.0885 11.2734 12.5938 11.9375 11.9688 12.5H13.25V13.625H9.875Z",
    fill: "#FBFBFB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublishedWithChanges);
export default __webpack_public_path__ + "static/media/published_with_changes.aaf57f4bb12a07fade29f02536c75799.svg";
export { ForwardRef as ReactComponent };